export const overrideClasses = {
  image: {
    borderRadius: 6,
  },
  imageContainer: {
    height: 80,
    display: 'flex',
  },
  imageParentContainer: {
    display: 'flex',
    columnGap: '10px',
  },
  imageClickableContainer: {
    width: 107,
    '& img': {
      verticalAlign: 'top',
    },
  },
  seeAll: {
    bottom: 12,
    maxWidth: 'initial',
  },
  parentContainer: {
    '& $panelHeading': {
      display: 'flex',
      border: 'none',
      '& $panelTitle.collapsible-title': {
        flexGrow: 0,
        fontSize: '12px',
        fontWeight: 600,
        lineHeight: '24px',
        '& > a': {
          '& .helpbutton': {
            fontSize: '14px',
            lineHeight: '24px',
            display: 'inline',
            verticalAlign: 'bottom',
          },
        },
        marginTop: 0,
      },
    },
  },
};
